import { Badge } from 'antd';
import clsx from 'clsx';
import React from 'react';
import { StatusColor } from 'types/Status';

export default function Tag({
  status,
  color,
  full = false,
  className,
  icon,
}: {
  status?: string;
  color: StatusColor;
  full?: boolean;
  className?: string;
  icon?: React.ReactNode;
}) {
  return status ? (
    <Badge
      className={clsx(full ? 'w-full' : '', className)}
      count={
        <span
          className={clsx(
            'py-2 px-3 rounded-[4px] -my-2 text-center text-white',
            full ? 'block w-full' : 'inline-block',
            icon ? '!flex items-center gap-2 !px-2' : '',
          )}
          style={{
            backgroundColor: color.bg,
            color: color.text,
          }}
        >
          {icon}
          <span>{status}</span>
        </span>
      }
    />
  ) : null;
}
